import { Player } from "@remotion/player";
import { useTranslation } from "react-i18next";
import { ComingSoonLoop } from "@/components/remotion/ComingSoonLoop";

interface Props {
  className?: string;
}

/**
 * Renders the branded Remotion "Coming Soon" loop, scaled to fill its parent.
 * Use anywhere a video thumbnail or player would normally render but the
 * Cloudflare upload is still processing.
 */
export const ComingSoonPlaceholder = ({ className }: Props) => {
  const { t } = useTranslation("common");

  return (
    <div className={`absolute inset-0 ${className ?? ""}`}>
      <Player
        component={ComingSoonLoop}
        inputProps={{
          label: t("coming_soon.title", "Coming Soon"),
          subtitle: t("coming_soon.subtitle", "Preparing your video"),
        }}
        durationInFrames={150}
        fps={30}
        compositionWidth={1920}
        compositionHeight={1080}
        loop
        autoPlay
        controls={false}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default ComingSoonPlaceholder;
